module.exports = __webpack_public_path__ + "img/Metal Crack.9536b482.png";